import * as RadioGroupGeneric from '@radix-ui/react-radio-group'
import { clsx } from 'clsx'
import * as React from 'react'

export const radioClasses = {
  itemContainer: (active: boolean) =>
    clsx(
      'group flex items-center gap-2 group-[[data-disabled]]/root:pointer-events-none',
      active || 'group-[[data-disabled]]/root:opacity-30'
    ),
  item: 'flex size-4 cursor-default items-center justify-center rounded-full border border-dark-elevated bg-dark-border radix-state-checked:border-dark-control-base radix-state-checked:bg-dark-control-base/15',
  label: (active: boolean) =>
    clsx(
      'select-none transition-colors group-hover:text-dark-dim',
      active && 'text-dark-dim'
    ),
  indicator: 'size-2 rounded-full bg-dark-control-base',
}

export type RadioGroupProps = RadioGroupGeneric.RadioGroupProps
export const RadioGroup = ({
  className,
  ...props
}: RadioGroupGeneric.RadioGroupProps) => {
  return (
    <RadioGroupGeneric.Root
      className={clsx(
        'flex items-center group/root gap-6 text-xs text-dark-muted',
        className
      )}
      {...props}
    ></RadioGroupGeneric.Root>
  )
}

export const RadioGroupItem = ({
  className,
  children,
  ...props
}: RadioGroupGeneric.RadioGroupItemProps) => {
  return (
    <RadioGroupGeneric.Item
      className={clsx(radioClasses.item, className)}
      {...props}
    >
      {children}
    </RadioGroupGeneric.Item>
  )
}

export const RadioGroupIndicator = ({
  className,
  ...props
}: RadioGroupGeneric.RadioGroupIndicatorProps) => {
  return (
    <RadioGroupGeneric.Indicator
      className={clsx(radioClasses.indicator, className)}
      {...props}
    />
  )
}

export type RadioGroupLabelProps = {
  isActive?: boolean
} & React.ComponentProps<'label'>

export const RadioGroupLabel = ({
  className,
  children,
  isActive = false,
  ...props
}: RadioGroupLabelProps) => {
  return (
    <label className={clsx(radioClasses.label(isActive), className)} {...props}>
      {children}
    </label>
  )
}

type RadioItemWithLabelProps = {
  children: React.ReactNode
  isActive?: boolean
} & RadioGroupGeneric.RadioGroupItemProps
export const RadioItemWithLabel = ({
  children,
  isActive,
  ...props
}: RadioItemWithLabelProps) => {
  const id = React.useId()
  return (
    <div className="flex items-center gap-2">
      <RadioGroupItem
        id={id}
        {...props}
        className="!outline-offset-2 outline-dark-control-base focus-visible:outline"
      >
        <RadioGroupIndicator />
      </RadioGroupItem>
      <RadioGroupLabel htmlFor={id} className={clsx(isActive)}>
        {children}
      </RadioGroupLabel>
    </div>
  )
}
